import { useStaticQuery, graphql } from "gatsby";
import _ from "lodash"

export const getPriceStr = ( price ) => {
  let priceStr = '';
  if (price.min && price.max) {
      priceStr = " between " + `£` + addCommas(price.min) + " and " + `£` + addCommas(price.max);
  } else if (price.max) {
      priceStr = " under " + `£` + addCommas(price.max);
  } else if (price.min) {
      priceStr = " above " + `£` + addCommas(price.min);
  }
  return priceStr;
}

export const getFloorStr = ( floor ) => {
  let floorStr = '';
  if (floor.min && floor.max) {
      floorStr = " between " + addCommas(floor.min) + " sqft and " + addCommas(floor.max)+" sqft";
  } else if (floor.max) {
      floorStr = " under " + addCommas(floor.max)+" sqft";
  } else if (floor.min) {
      floorStr = " above " + addCommas(floor.min)+" sqft";
  }
  return floorStr;
}

function addCommas(num) {
  // console.log('num : ' + num);
  var str = num.toString().split('.');
  // console.log('str, ' + str);
  if (str[0].length >= 4) {
      // add comma every 3 digits before decimal
      str[0] = str[0].replace(/(\d)(?=(\d{3})+$)/g, '$1,');
  }
  /* Optional formating for decimal places
  if (str[1] && str[1].length >= 4) {
      // add space every 3 digits after decimal
      str[1] = str[1].replace(/(\d{3})/g, '$1 ');
  }*/
  return str.join('.');
}

export const ACTION_TYPES = {
  sales: " for sale in ",
  lettings: " to rent in ",
}

export const pTypeBase = {
  sales: "/property/for-sale/",
  lettings: "/property/to-rent/",
}

export const toTitleCase = (text) => {
  let _text = text || '';
    _text = _text.trim();

    _text = _text.charAt(0).toUpperCase() + _text.slice(1);
  // if ( _text ) {
  //   _text = _text.trim().split(' ');
  //   if ( _text.length > 0 ) {
  //     _text = _text.map(w => w[0].toUpperCase() + w.substr(1).toLowerCase()).join(' ');
  //   }
  // }
  return _text;
}

// TODO: hard coded details to be removed/replaced with common variables
export const parseSearchUrl = (pType, location, path, department) => {
  if (location) {
      var query = '';
      //let pathUri_main = location.split(pTypeBase[pType].slice(0, -1))
      let pathUri_main = location.split(path.slice(0, -1))
      var areaVal = ''
      var bedVal = ''
      var minpriceVal = ''
      var maxpriceVal = ''
      var typeVal = ''
      var mustIncludeVal = ''
      var minfloorVal = ''
      var maxfloorVal = ''
      if( pathUri_main[1] ) { // following could be regexp
        let pathUri = pathUri_main[1].split('/');
        
        //lets loop
        for(let vi = 1; vi <= pathUri.length; vi++ ) {
          // check for area
          if( typeof pathUri[vi] === "undefined" ) {continue;}
          // for-sale
          if ( pathUri[vi].indexOf("for-sale") >= 0 ) {
            // its area
            pType = 'sales';
          }
          if ( pathUri[vi].indexOf("to-rent") >= 0 ) {
            // its area
            pType = 'lettings';
          }
          if ( pathUri[vi].indexOf("in-") == 0 ) {
            // its area
            areaVal = pathUri[vi].replace("in-","").replace("-"," ");
          }
          if ( pathUri[vi].indexOf("-and-more-") >= 0 ) {
            // its bedrooms
            bedVal = pathUri[vi].replace("-and-more-bedrooms","")
          }
          if ( pathUri[vi].indexOf("studio") >= 0 ) {
            // its studio bedroom
            bedVal = 0
          }
          if ( pathUri[vi].indexOf("between-") >= 0 || 
               pathUri[vi].indexOf("over-") >= 0 || 
               pathUri[vi].indexOf("under-") >= 0
             ) {
            // its price
            let priceFilt1 = pathUri[vi].split('over-');
            if( priceFilt1[1] ) {
              minpriceVal = priceFilt1[1]
            }
            let priceFilt2 = pathUri[vi].split('under-');
            if( priceFilt2[1] ) {
              maxpriceVal = priceFilt2[1]
            }
            let priceFilt3 = pathUri[vi].split('between-');
            if( priceFilt3[1] ) {
              let priceFilt4 = priceFilt3[1].split('-and-');
              minpriceVal = priceFilt4[0]
              maxpriceVal = priceFilt4[1]
            }
          }

          if ( pathUri[vi].indexOf("sqft-") >= 0 || 
               pathUri[vi].indexOf("minsqft-") >= 0 || 
               pathUri[vi].indexOf("maxsqft-") >= 0
             ) {
            // its floor
            let floorFilt1 = pathUri[vi].split('minsqft-');
            if( floorFilt1[1] ) {
              minfloorVal = floorFilt1[1]
            }
            let floorFilt2 = pathUri[vi].split('maxsqft-');
            if( floorFilt2[1] ) {
              maxfloorVal = floorFilt2[1]
            }
            let floorFilt3 = pathUri[vi].split('sqft-');
            if( floorFilt3[1] ) {
              let floorFilt4 = floorFilt3[1].split('-and-');
              minfloorVal = floorFilt4[0]
              maxfloorVal = floorFilt4[1]
            }
          }

          // Must Include
          if (pathUri[vi].indexOf("with-") >= 0) {
            var mustIncludeArrfilt = pathUri[vi].replace("with-", "")
            mustIncludeVal = mustIncludeArrfilt.split("-and-")
          }
          let priceFilt5 = pathUri[vi].split('type-');
          if( priceFilt5[1] ) {
            typeVal = priceFilt5[1]
          }
        }
      }

    // If no area send default to set default loaction
    // We could send defaut location
    if (!areaVal || areaVal === 'undefined') {
        areaVal = "London"; // TODO
    }

    var areaAlias = areaVal.replace(' ', '-');

    return {
      department: department,
      pType: pType,
      areas: areaVal,
      areas_alias: areaAlias,
      bedrooms: bedVal,
      type: typeVal,
      mustInclude: mustIncludeVal,
      price: {
        min: minpriceVal,
        max: maxpriceVal,
      },
      floor: {
        min: minfloorVal,
        max: maxfloorVal,
      },
      extra: {
        bedPlus: false,
        areasTitleCase: true
      }
    }
  }
}

// TODO: hard coded details to be removed/replaced with common variables
export const savedSearchParams = (params) => {
  const {areas, bedrooms, pType, type, price, mustInclude, department, floor} = params;

  let searchItems =  {
    department: department,
    search_type: pType,
    areas: areas,
    bedroom: bedrooms,
    minPrice:  price.min,
    maxPrice:  price.max,
    building: type,
    must_Include: mustInclude,
    minFloor:  floor.min,
    maxFloor:  floor.max,
  }

  return _.pickBy(searchItems, _.identity)
}


// TODO: hard coded details to be removed/replaced with common variables
const capitalize = (s) => {
  if (typeof s !== 'string') return ''
  return s.charAt(0).toUpperCase() + s.slice(1)
}

export const propertyH1 = (params) => {
  // console.log('params : ' + params);

  const {areas, bedrooms, pType, type, price, extra, mustInclude, department, floor} = params;
   console.log('floor ==>', floor);

  let h1 = "";
  let building = "";

  if ('Commercial' === pType) { // TODO
    // Commercial Property [action] in [default search area] for Sale and Rent
    building = "Commercial ";

    if (type)
      building += ` ${type} `;
    else
      building += ` Property `;

    h1 += `${building} in `;

    if (areas) {
      h1 += areas;
    }

    h1 += ` for sale and rent`;

  } else {
    let building = "Property";

    if(department === "new_developments"){
      if (type) {
        if(type == "apartment") {
          building = "New apartments"
        } else if(type == "house") {
            building = "New houses"
        } else if(type == "bungalow") {
            building = "New bungalows"
        } else if(type == "new-home") {
            building = "New homes"
        } else if(type == "terrace") {
          building = "New terraced houses"
        } else if(type == "semi-detached-house") {
          building = "New semi detached houses"
        } else {
          building = `New ${(type)} `;
        }
      } else {
        building = ` New homes`;
      }

    } else{
      if (type) {
        if(type == "apartment") {
          building = "Apartments"
        } else if(type == "house") {
            building = "Houses"
        } else if(type == "bungalow") {
            building = "Bungalows"
        } else if(type == "new-home") {
            building = "New homes"
        } else if(type == "terrace") {
          building = "Terraced houses"
        } else if(type == "detached-house") {
          building = "Detached houses"
        } else if(type == "semi-detached-house") {
          building = "Semi detached houses"
        } else {
          building = `${type} `;
        }
      } else {
        if(department === "commercial"){
          building = ` Commercial property `;
        } else{
          building = `Property `;
        }
      }
    }


    h1 += toTitleCase(building);
    h1 += ACTION_TYPES[pType];

    if (areas) {
      let _areas = areas;
      _areas = _areas.replace("-"," ");
      _areas = decodeURIComponent(_areas);
      _areas = extra.areasTitleCase ? toTitleCase(_areas) : _areas;
      h1 += _areas.replace("north","North").replace("road","Road")
    }

    if (bedrooms) {
      let bedPlus = extra.bedPlus ? '+' : '+';
      if(bedrooms > 1)
        h1 += " with more than "+bedrooms+" bedrooms";
      else
        h1 += " with more than "+bedrooms+" bedroom";
    }

    if ( floor && (floor.min || floor.max) )  {
      h1 += getFloorStr(floor);
    }

    if ( price && (price.min || price.max) )  {
      h1 += getPriceStr(price);
    }

    // if ( mustInclude ) {
    //   h1 += " with "+mustInclude.join('-and-').toLowerCase()
    // }

    if ( mustInclude ) {
      h1 += " with "+mustInclude.join('-and-').toLowerCase()
      h1 = h1.replaceAll("-", " ")
      //console.log(h1)
    }
  }

  // console.log("H1 title => ", h1);
  return h1;
}